import {
  Accessories,
  Banner,
  BestSeller,
  Category,
  Floor,
  MoreProduct,
  Storyblock,
  Subscribe,
  WhyChooseUs,
  WhyChooseUsV2,
} from '../Homepage/_components'
import {
  BannerType,
  BestSellerType,
  CategoryDataType,
  FloorType,
  HtmlType,
  ProductMoreType,
  ProductRecommandType,
  ServicesType,
  StoryblockType,
  SubscribeType,
  WhyChooseUsBlockData,
} from '../Homepage/_components/types'

import { Html } from './_components'

export type TBuilderPageProps = {
  pageData: {
    type: string
    identify: string
    block_data:
      | HtmlType
      | BannerType
      | FloorType
      | CategoryDataType
      | ProductMoreType
      | BestSellerType
      | SubscribeType
      | ServicesType
      | ProductRecommandType
      | StoryblockType
  }[]
}

const BuilderPage = ({ pageData }: TBuilderPageProps) => {
  if (!pageData.length) {
    return <></>
  }

  return (
    <>
      {pageData.map((item) => {
        switch (item.type) {
          case 'banner_slider':
            return <Banner blockData={item.block_data as BannerType} key={item.identify} />
          default:
            return null
        }
      })}

      <div className="flex w-full flex-col items-center justify-center gap-[104px] pb-[104px] max-xl:gap-[48px] max-xl:pb-[48px]">
        {pageData.map((item) => {
          switch (item.type) {
            case 'cms_contact_us':
              return <Html key={item.identify} blockData={item.block_data as HtmlType} />
            case 'category':
              return (
                <Category blockData={item.block_data as CategoryDataType} key={item.identify} />
              )
            case 'best_seller':
              return (
                <BestSeller
                  blockData={item.block_data as BestSellerType}
                  key={item.identify}
                  identify={item.identify}
                />
              )
            case 'recommend_card_no_products':
              return (
                <Floor
                  type={4}
                  blockData={item.block_data as FloorType}
                  key={item.identify}
                  identify={item.identify}
                />
              )
            case 'recommend_card_4_products':
              return (
                <Floor
                  type={4}
                  blockData={item.block_data as FloorType}
                  key={item.identify}
                  identify={item.identify}
                />
              )
            case 'recommend_card_3_products':
              return (
                <Floor
                  type={3}
                  blockData={item.block_data as FloorType}
                  key={item.identify}
                  identify={item.identify}
                />
              )
            case 'recommend_card_2_products':
              return (
                <Floor
                  type={2}
                  blockData={item.block_data as FloorType}
                  key={item.identify}
                  identify={item.identify}
                />
              )
            case 'more_product':
              return (
                <MoreProduct
                  blockData={item.block_data as ProductMoreType}
                  key={item.identify}
                  identify={item.identify}
                />
              )
            case 'product_recommand_list':
              return (
                <Accessories
                  blockData={item.block_data as ProductRecommandType}
                  key={item.identify}
                  identify={item.identify}
                />
              )
            case 'services':
              return <WhyChooseUs blockData={item.block_data as ServicesType} key={item.identify} />
            case 'block_service_v1':
              return (
                <WhyChooseUsV2
                  blockData={item.block_data as WhyChooseUsBlockData}
                  key={item.identify}
                />
              )
            case 'subscribe':
              return <Subscribe blockData={item.block_data as SubscribeType} key={item.identify} />
            default:
              return null
          }
        })}
      </div>

      {pageData.map((item) => {
        switch (item.type) {
          case 'homepage_firework':
            return <Storyblock blockData={item.block_data as StoryblockType} key={item.identify} />
          default:
            return null
        }
      })}
    </>
  )
}

export default BuilderPage
